<template>
  <div class="replenishmentdetails">
    <el-card class="box-card">
      <div slot="header">
        <span class="ft20 D1D1D1">销量目标</span>
      </div>
      <div class="flex justify_content_between mtb520">
        <div>
          <!-- 销量目标 -->
          <el-select
            size="small"
            v-model="salesTarget"
            clearable
            placeholder="请选择销量目标"
            @change="saleChange"
          >
            <el-option
              v-for="item in salesTargets"
              :key="item.dictCode"
              :label="item.dictValue"
              :value="item.dictCode"
            >
            </el-option>
          </el-select>
          <!-- 任务类型 -->
          <el-select
            class="ml20"
            size="small"
            v-model="taskType"
            clearable
            placeholder="请选择任务类型"
            @change="saleChange"
          >
            <el-option
              v-for="item in taskTypes"
              :key="item.dictCode"
              :label="item.dictValue"
              :value="item.dictCode"
            >
            </el-option>
          </el-select>
        </div>
        <div>
          <el-button
            size="small"
            type="primary"
            icon="el-icon-refresh-right"
            @click="queryClick"
            >查询</el-button
          >
          <el-button
            size="small"
            type="primary"
            plain
            icon="el-icon-refresh-right"
            @click="resetClick"
            >重置</el-button
          >
        </div>
      </div>
      <div class="text item announcementview_content">
        <el-table
          v-loading="loading"
          element-loading-spinner="el-icon-loading"
          :data="tableData"
          :header-cell-style="{
            fontSize: '13px',
            color: '#787878',
            background: '#F5F5F5',
            textAlign: 'center',
          }"
          :cell-style="{
            fontSize: '14px',
            color: '#140000',
            textAlign: 'center',
          }"
          style="width: 100%"
        >
          <el-table-column align="center" prop="typeName" label="销量目标类型">
          </el-table-column>
          <el-table-column align="center" prop="taskType" label="任务类型">
          </el-table-column>
          <el-table-column align="center" prop="targetYear" label="年度">
          </el-table-column>
          <el-table-column align="center" prop="name" label="销量目标名称">
          </el-table-column>
          <el-table-column align="center" prop="cusCode" label="客户编码">
          </el-table-column>
          <el-table-column align="center" prop="cusName" label="客户名称">
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button
                @click="handleClick(scope.row)"
                type="text"
                size="small"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pageschange">
        <el-pagination
          class="w200 marginauto30"
          background
          prev-text="上一页"
          next-text="下一页"
          layout="total,prev, pager, next"
          :total="total"
          :current-page="pageNum"
          @current-change="getList()"
        >
          <!-- :current-page="1"
          @current-change="sizeChange" -->
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>
<script>
/**
 *   @Author : 丁江
 *   @Date : 2021/3/30
 *   @Version : 1.0.0
 *   @Last Modified by : 丁江
 *   @Last Modified time : 2021/3/30
 *   @desc 任务查询列表请求
 **/
import { QueryContract, getList } from "@/api/api";
import { Storage } from "@/utils/storage";
export default {
  name: "replenishmentdetails",
  data() {
    return {
      salesTarget: "", //销量目标
      salesTargets: [],
      taskType: "", //任务类型
      taskTypes: [],
      tableData: null,
      param: {}, //列表查询参数
      total: 0,
      pageSize: 10,
      pageNum: 1,
      loading: true,
    };
  },
  methods: {
    //获取下拉框数据
    getSaleTargetList() {
      QueryContract({ dictTypeCode: "salesTarget_type" }).then((res) => {
        this.salesTargets = res.result;
      });
      QueryContract({ dictTypeCode: "dms_target_task" }).then((res) => {
        this.taskTypes = res.result;
      });
    },
    //获取列表数据
    getList(param) {
      getList(param).then((res) => {
        this.total = res.result.count;
        let { data } = res.result;
        this.loading = false;
        let arr = data.map((item) => {
          let obj = {};
          obj.typeName = item.typeName;
          obj.targetYear = item.targetYear;
          obj.name = item.name;
          obj.cusCode = item.cusCode;
          obj.cusName = item.cusName;
          obj.id = item.id;
          switch (item.taskType) {
            case 1:
              item.taskType = "年度";
              break;
            case 2:
              item.taskType = "季度";
              break;
            case 3:
              item.taskType = "月度";
              break;
          }
          obj.taskType = item.taskType;
          return obj;
        });
        this.tableData = arr;
      });
    },
    //下拉框数据变化
    saleChange() {
      this.param.type = this.salesTarget;
      this.param.taskType = this.taskType;
    },
    //查询
    queryClick() {
      this.getList(this.param);
    },
    //重置
    resetClick() {
      this.param.type = this.salesTarget = "";
      this.param.taskType = this.taskType = "";
      this.param.pageNum = 1;
      this.getList(this.param);
    },
    //跳转至详情
    handleClick(row) {
      this.$router.push(`/home/main/taskDetail?id=${row.id}`);
    },
    // //页码变化监听函数
    // sizeChange(val) {
    //   this.loading = true;
    //   this.param.pageNum = val;
    //   this.getList(this.param);
    // },
  },
  mounted() {
    this.param = {
      pageNum: 1,
      pageSize: 10,
      type: null,
      taskType: null,
    };
    this.param.cusCode = Storage.l.get("customerCode");
    this.getSaleTargetList();
    this.getList(this.param);
  },
};
</script>
<style lang="scss" scoped>
.replenishmentdetails {
  height: 100%;
  .el-card {
    height: 100%;
    /deep/.el-card__header {
      border-bottom: 0;
      padding: 20px 20px 0px 20px;
    }
    // 选择框图标
    /deep/ .el-icon-arrow-up:before {
      content: "\e790";
    }
    /deep/.el-input__inner {
      border-radius: 2px;
      background: #f5f5f5;
    }
    /deep/ .el-range-editor.el-input__inner {
      width: 150px;
    }
    /deep/ .el-range-input {
      background: #f5f5f5;
    }
    //分页
    .pageschange {
      margin: 20px auto;
      text-align: center;
    }
  }
}
</style>
